import type { ApiAddress } from '@Model';
import { FrameEditAddress } from '@Modules/Stammdaten';
import { addressColumns } from '@Constants/TableColumns';
import { BaseLinkableCell, type SharedLinkableCellProps } from './BaseLinkableCell';

export function LinkableAddressCell<TParent>(props: SharedLinkableCellProps<TParent>) {
    return (
        <BaseLinkableCell<TParent, ApiAddress>
            {...props}
            overlayRenderer={FrameEditAddress}
            columns={addressColumns}
            badgeKeyPrefix="address"
        />
    );
}
